// extracted by mini-css-extract-plugin
export default {"page_container":"centered-page-container_page_container__Y3Av8","centered_content":"centered-page-container_centered_content__uiEQB"};